import React from 'react'
import PropTypes from 'prop-types'
import ShareUser from './ShareUser'
import MultiUseLink from './MultiUseLink/MultiUseLink'
import InviteForm from './InviteForm/InviteFormContainer'
import { OWNER, EDITOR } from '../../constants'
import { StyledDetailsBox as DetailsBox } from '../common/DetailsBox'
import Text from 'common/components/Text'
import { StyledFormElement as FormElement } from '../common/FormElement'
import { Trans } from 'react-i18next'
import Toolbar from '../common/Toolbar'
import Icon from 'common/components/Icon'
import { Hr } from 'common/components'
import { ShareRow } from './ShareRow'
import styled from 'react-emotion'
import { ScrollArea } from 'common/components'

const SectionHeader = styled('div')({
  label: 'SectionHeader',
  marginBottom: 25
})

export const ShareModal = ({
  item,
  childCounts,
  users,
  access,
  invites,
  viewLink,
  discussLink,
  editLink,
  t
}) => (
  <div style={{ fontSize: 14 }}>
    <ScrollArea>
      <Toolbar large borderless>
        <FormElement large shrink>
          <Text truncate>
            <Trans i18nKey="share.modalTitle">
              ShareModal <Text bold>{{ name: item.name }}</Text>
            </Trans>
          </Text>
        </FormElement>

        <FormElement.Spacer />

        {item.type === 'folder' && (
          <FormElement large>
            <Text grey>
              {(childCounts.board && childCounts.folder) ||
              childCounts.board === childCounts.folder
                ? t('share.folderContents.bothTypes', {
                    boards: t('share.folderContents.boards', {
                      count: childCounts.board
                    }),
                    folders: t('share.folderContents.folders', {
                      count: childCounts.folder
                    })
                  })
                : t('share.folderContents.oneType', {
                    things: t(
                      `share.folderContents.${
                        childCounts.board ? 'boards' : 'folders'
                      }`,
                      { count: childCounts.board + childCounts.folder }
                    )
                  })}
            </Text>
          </FormElement>
        )}
      </Toolbar>

      {/* Link Access */}
      <MultiUseLink share={viewLink} item={item} editable={access >= EDITOR} />
      {/* Discussers can't access this because they can't read the share list FIXME */}
      {access >= EDITOR && (
        <MultiUseLink
          share={discussLink}
          item={item}
          editable={access >= EDITOR}
        />
      )}
      {access >= EDITOR && (
        <MultiUseLink share={editLink} item={item} editable />
      )}

      {/* Hr has negative margin because it expects modal to have padding - share modal does not */}
      <Hr style={{ margin: 0 }} /> 

      <DetailsBox>
        <SectionHeader>
          <Text grey>{t('share.userList')}</Text>
        </SectionHeader>

        {/* Link Access */}
        {((viewLink && !viewLink.disabled) ||
          (discussLink && !discussLink.disabled) ||
          (editLink && !editLink.disabled)) && (
          <ShareRow>
            <ShareRow.Circle>
              <Icon icon="link" />
            </ShareRow.Circle>
            <Text medium>{t('share.linkAccess')}</Text>
          </ShareRow>
        )}

        {/* Owner */}
        <ShareUser
          share={{ user: item.owner, accessLevel: OWNER, dateAccepted: 1 }}
        />

        {/* Shared Users */}
        {users.map(share => (
          <ShareUser
            key={share.id}
            item={item}
            share={share}
            editable={access >= EDITOR}
          />
        ))}

        {/* Pending Users */}
        {invites.map(invite => (
          <ShareUser
            key={invite.id}
            item={item}
            share={invite}
            editable={access >= EDITOR}
          />
        ))}
      </DetailsBox>
    </ScrollArea>

    {/* Invite */}
    {access >= EDITOR && <InviteForm item={item} />}
  </div>
)

ShareModal.propTypes = {
  item: PropTypes.object,
  shares: PropTypes.object
}

export default ShareModal
